import { apiFetch } from "./client";
import Report from "../dto/Report";

async function parseError(response) {
    try {
        const json = await response.json();

        return (
            json.error ||
            json.errors?.join(", ") ||
            `Request failed with status ${response.status}`
        );
    } catch {
        return `Request failed with status ${response.status}`;
    }
}

export async function fetchReports() {
    const response = await apiFetch("/api/reports");

    if (!response.ok) {
        throw new Error(await parseError(response));
    }

    const json = await response.json();

    return json.reports.map((report) => new Report(report));
}

export async function fetchReport(id) {
    const response = await apiFetch(`/api/reports/${id}`);

    if (!response.ok) {
        throw new Error(await parseError(response));
    }

    const json = await response.json();

    return new Report(json.report);
}

export async function uploadReport({ title, file }) {
    const formData = new FormData();

    formData.append("report[title]", title);
    formData.append("report[file]", file);

    const response = await apiFetch("/api/reports", {
        method: "POST",
        body: formData,
    });

    if (!response.ok) {
        throw new Error(await parseError(response));
    }

    const json = await response.json();

    return new Report(json.report);
}

export async function deleteReport(id) {
    const response = await apiFetch(`/api/reports/${id}`, {
        method: "DELETE",
    });

    if (!response.ok) {
        throw new Error(await parseError(response));
    }
}

export async function assignReportRowExpense({ reportId, rowId, expenseId }) {
    const response = await apiFetch(`/api/reports/${reportId}/rows/${rowId}`, {
        method: "PATCH",
        body: JSON.stringify({
            report_row: {
                expense_id: expenseId,
            },
        }),
    });

    if (!response.ok) {
        throw new Error(await parseError(response));
    }

    const json = await response.json();

    return new Report(json.report);
}
